import { Fragment } from 'react';

import { FeaturedVendorsToolTip } from '../FeaturedVendorsToolTip/FeaturedVendorsToolTip';
import { PageTitle } from '../PageTitle/PageTitle';
import { TotalVendorsDescriptionProps } from './types';

import styles from './totalVendorsDescription.module.less';

export const TotalVendorsDescription = ({
  totalHits,
  selectedTaxonomy,
  selectedLocation,
  selectedFacets,
  ...rest
}: TotalVendorsDescriptionProps): JSX.Element => {
  if (totalHits === 0) {
    return <Fragment />;
  }
  return (
    <div className={styles.totalVendors} {...rest}>
      <span data-testid="search-title">
        <PageTitle
          selectedTaxonomy={selectedTaxonomy}
          selectedLocation={selectedLocation}
          selectedFacets={selectedFacets}
          totalHits={totalHits}
        />
      </span>
      <FeaturedVendorsToolTip />
    </div>
  );
};
